import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    switch (curPageId) {
        case 'godt-at-vide':
            return 'har-ejeren-anmeldt-skaden';
        case 'har-ejeren-anmeldt-skaden':
            return 'om-ejeren';
        case 'om-ejeren':
            return 'dato';
        case 'dato':
            return 'adresse';
        case 'adresse':
            return 'var-du-sammen-med-ejeren';
        case 'var-du-sammen-med-ejeren':
            return 'beskriv-skaden';
        case 'beskriv-skaden':
            return 'beskriv-skaden-paa-bygningen';
        case 'beskriv-skaden-paa-bygningen':
            return 'om-bygningen';
        case 'om-bygningen':
            return 'skadevolder';
        case 'skadevolder':
            if (getValueOrDefault(formConfig, formValues, 'hvemforrsagedeskaden').value === 'Min hund') {
                return 'om-hunden';
            } else {
                return 'alder';
            }
        case 'om-hunden':
            return 'blev-hunden-passet';
        case 'blev-hunden-passet':
            if (getValueOrDefault(formConfig, formValues, 'blevdinhundpassetafejerenafdetdelagte').value === 'Ja') {
                return 'pasningstidspunkt';
            } else {
                return 'om-ansvar';
            }
        case 'pasningstidspunkt':
            return 'om-ansvar';
        case 'alder':
            return 'om-koeretoej';
        case 'om-koeretoej':
            if (
                getValueOrDefault(formConfig, formValues, 'erskadenbegetmedetkretjellerenmotoriseretgenstand').value ===
                'Ja'
            ) {
                return 'om-koeretoej-eller-genstand';
            } else if (
                getValueOrDefault(formConfig, formValues, 'erskadenbegetmedetkretjellerenmotoriseretgenstand').value ===
                'Andet'
            ) {
                return 'beskriv-hvordan';
            } else {
                return 'om-ansvar';
            }
        case 'om-koeretoej-eller-genstand':
            return 'om-ansvar';
        case 'beskriv-hvordan':
            return 'om-ansvar';
        case 'om-ansvar':
            return 'politianmeldelse';
        case 'politianmeldelse':
            if (getValueOrDefault(formConfig, formValues, 'policeContacted').value === 'Ja') {
                return 'om-anmeldelsen';
            } else {
                return 'dokumentation';
            }
        case 'om-anmeldelsen':
            return 'samtykke';
        case 'samtykke':
            return 'dokumentation';
        case 'dokumentation':
            return 'andet-selskab';
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                return 'hvilket-selskab';
            } else {
                return 'om-dig';
            }
        case 'hvilket-selskab':
            return 'om-dig';
        case 'om-dig':
            return 'resume';
        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
